import React from 'react'

class NotFound extends React.Component {
  render() {
    return(
      <section className="pfb-404-splash-container">
        <div className="pfb-404-image"></div>
        <div className="pfb-404-text-container">
          <h1 className="pfb-404-title">404</h1>
          <p className="pfb-404-text">
            You took a wrong turn.&nbsp;
            <a href={ this.props.path }>Click here to jump back in</a>.
          </p>
        </div>
      </section>
    )
  }
}

export default NotFound


// WEBPACK FOOTER //
// ./src/components/NotFound/index.js